export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<g clip-path="url(#clip0_134_5517)">
			<path
				d="M15.7324 12.6172L10.4824 17.8672C10.2363 18.1133 9.78516 18.1133 9.53906 17.8672C9.29297 17.6211 9.29297 17.1699 9.53906 16.9238L13.6816 12.7812H2.15625C1.78711 12.7812 1.5 12.4941 1.5 12.125C1.5 11.7969 1.78711 11.4688 2.15625 11.4688H13.6816L9.53906 7.36719C9.29297 7.12109 9.29297 6.66992 9.53906 6.42383C9.78516 6.17773 10.2363 6.17773 10.4824 6.42383L15.7324 11.6738C15.9785 11.9199 15.9785 12.3711 15.7324 12.6172ZM15.2812 20H19.2188C20.2852 20 21.1875 19.1387 21.1875 18.0312V6.21875C21.1875 5.15234 20.2852 4.25 19.2188 4.25H15.2812C14.9121 4.25 14.625 3.96289 14.625 3.59375C14.625 3.26562 14.9121 2.9375 15.2812 2.9375H19.2188C21.0234 2.9375 22.5 4.41406 22.5 6.21875V18.0312C22.5 19.877 21.0234 21.3125 19.2188 21.3125H15.2812C14.9121 21.3125 14.625 21.0254 14.625 20.6562C14.625 20.3281 14.9121 20 15.2812 20Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_134_5517">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
